import { Codebook } from '../Codebook'
import { $t } from '../../composables/i18n'
import { Color } from '../color/Color'
import { StringUtils } from '../../utils/String'

export enum ReservationPaymentStatusId {
  PAID = 1,
  NOT_PAID = 2,
  PARTLY_PAID = 3,
}

export class ReservationPaymentStatus extends Codebook<ReservationPaymentStatusId> {
  private constructor(
    id: ReservationPaymentStatusId,
    public readonly name: () => string,
    // must be same as colors available in p-tag
    public readonly color:
      | Color.POSITIVE
      | Color.WARNING
      | Color.NEGATIVE
      | Color.INFO
      | Color.GREY_600,
    // used by p-indicator
    public readonly colorLight: Color.POSITIVE_LIGHT | Color.WARNING_LIGHT | Color.NEGATIVE_LIGHT,
  ) {
    super(id)
  }

  static readonly PAID = new ReservationPaymentStatus(
    ReservationPaymentStatusId.PAID,
    () => $t('paid'),
    Color.POSITIVE,
    Color.POSITIVE_LIGHT,
  )
  static readonly PARTLY_PAID = new ReservationPaymentStatus(
    ReservationPaymentStatusId.PARTLY_PAID,
    () => $t('partly paid'),
    Color.WARNING,
    Color.WARNING_LIGHT,
  )
  static readonly NOT_PAID = new ReservationPaymentStatus(
    ReservationPaymentStatusId.NOT_PAID,
    () => $t('not paid'),
    Color.NEGATIVE,
    Color.NEGATIVE_LIGHT,
  )

  public nameCapitalize(): string {
    return StringUtils.capitalize(this.name())
  }
}
